export default __webpack_public_path__ + "static/media/coming-soon-header-bg.53e8c78a.png";